import { Button } from "../../../shared/ui";

type Props = {
  isInProgress: boolean;
  onStart: () => void;
  onMarkDone: () => void;
  onFollowUp: () => void;
  onReschedule: () => void;
};

export const AppointmentActions = ({ isInProgress, onStart, onMarkDone, onFollowUp, onReschedule }: Props) => (
  <div
    className="mt-auto bg-white border-t border-gray-200 px-4 pt-4 space-y-2"
    style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
  >
    {isInProgress ? (
      <Button
        className="!bg-green-500 !text-white flex items-center justify-center gap-2"
        onClick={onMarkDone}
      >
        Arbeit beenden
      </Button>
    ) : (
      <Button
        className="!bg-green-500 !text-white flex items-center justify-center gap-2"
        onClick={onStart}
      >
        Arbeit starten
      </Button>
    )}

    <div className="flex gap-2">
      {!isInProgress && (
        <Button
          size="sm"
          variant="surface"
          className="border-2 border-[#124093] !text-[#124093] flex items-center justify-center gap-1.5"
          onClick={onReschedule}
        >
          Umplanen
        </Button>
      )}
      {isInProgress && <Button
        size="sm"
        variant="surface"
        className="border-2 border-yellow-500 !text-yellow-600 flex items-center justify-center gap-1.5"
        onClick={onFollowUp}
      >
        Folgetermin
      </Button>}
    </div>  
  </div>
);
